import {
    VisualComponentsSection,
    VisualComponentsSectionName, VisualComponentsSectionsOrder
} from '@mintdata-wsp/common/state/ui/visualDesigner/SurfaceEditorState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {InputStyle} from '@mintdata-wsp/wsp/ui/components/forms/Input';
import {InputField} from '@mintdata-wsp/wsp/ui/components/forms/InputField';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {Scrollable, ScrollBehavior} from '@mintdata-wsp/wsp/ui/components/scrollable/Scrollable';
import {SurfaceComponentsSectionView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/panels/outline/components/SurfaceComponentsSectionView';
import {SurfaceOutlinePanelPartWrapper} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/panels/outline/SurfaceOutlinePanelPartWrapper';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SurfaceComponents.less');
const cx = classnames.bind(styles);

interface SurfaceComponentsProps
{
    onExpand?: () => void,
    onCollapse?: () => void,
    className?:string,
}

@observer
export class SurfaceComponents extends React.Component<SurfaceComponentsProps, any>
{
    @bind
    private _setSurfaceComponentsPanelCollapsed(isCollapsed:boolean):void
    {
        const {onExpand, onCollapse} = this.props;
        controllers.ui.workbenchVisibility.setSurfaceComponentsPanelCollapsed(isCollapsed);

        if (isCollapsed && onCollapse)
            onCollapse();
        else if (onExpand)
            onExpand();
    }

    private _renderFilterUI = ():JSX.Element =>
    {
        return <Row className={cx('filterRow')}>
            <InputField
                style={InputStyle.Simple}
                className={cx('inputField')}
                labelClassName={cx('inputFieldLabel')}
                label={null}
                icon={null}
                placeholder={'Filter'}
                initialValue={''}
                isInitiallyFocused={false}
                onChange={(newValue:any) =>
                {
                    const controller = controllers.ui.workbench;

                    if( !newValue || newValue.length === 0 )
                        controller.setFilterString(null);
                    else
                        controller.setFilterString(newValue);

                    return true;
                }}
            />
        </Row>;
    };

    private _renderVisualComponentsBySections = ():JSX.Element[] =>
    {
        const vcSections:Map<VisualComponentsSectionName, VisualComponentsSection> =
            controllers.ui.workbench.getVisibleVisualComponentsSections();

        return VisualComponentsSectionsOrder.map((sectionName:VisualComponentsSectionName) =>
        {
            const vcSection = vcSections && vcSections.get(sectionName);

            if( !vcSection )
                return null;

            return <SurfaceComponentsSectionView section={vcSection} key={vcSection.id}/>;
        });
    };

    componentWillUnmount():void
    {
        controllers.ui.workbench.setFilterString(null);
    }

    render()
    {
        const isCollapsed:boolean = controllers.ui.workbenchVisibility.isSurfaceComponentsPanelCollapsed();
        const {className} = this.props;

        return (
            <SurfaceOutlinePanelPartWrapper
                className={cx('base', {[className]: !!className})}
                title="Components"
                isCollapsed={isCollapsed}
                onCollapseChanged={this._setSurfaceComponentsPanelCollapsed}
            >
                <div className={cx('panelContent')}>
                    {this._renderFilterUI()}

                    <Scrollable
                        isScrollX={true}
                        isScrollY={true}
                        behavior={ScrollBehavior.OnHover}
                        className={cx('componentsList')}
                    >
                        {this._renderVisualComponentsBySections()}
                    </Scrollable>
                </div>
            </SurfaceOutlinePanelPartWrapper>
        );
    }
}
